import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
// 🚨 IMPORTAMOS LOS SERVICIOS CORRECTOS PARA PLATAFORMAS
import { obtenerPlataformasExternas, guardarPlataforma, eliminarPlataforma } from '../../services/ConfiguracionServicio'; 

// 🚩 DEFINICIÓN DEL MODAL (AHORA ESTÁ AQUÍ)
const PlatformFormModal = ({ isVisible, onClose, onSave, platformToEdit }) => {
    const [platform, setPlatform] = useState({ nombre_plataforma: '', porcentaje_comision: 0.00, recargo_cliente: 0.00, activo: 1 });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isVisible) {
            setPlatform(platformToEdit || { nombre_plataforma: '', porcentaje_comision: 0.00, recargo_cliente: 0.00, activo: 1 });
        }
    }, [platformToEdit, isVisible]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!platform.nombre_plataforma) return toast.warning("El nombre es obligatorio");
        
        setIsLoading(true);
        try {
            // 🚩 LLAMAMOS A LA FUNCIÓN CORRECTA: guardarPlataforma
            await guardarPlataforma(platform); 
            onSave();
        } catch (err) { toast.error("Error al guardar plataforma"); }
        finally { setIsLoading(false); }
    };

    if (!isVisible) return null;

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', overflowY: 'auto', zIndex: 1070 }}>
            <div className="modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content shadow-lg rounded-xl">
                    <div className="modal-header bg-primary text-white border-0 pt-4 px-4">
                        <h5 className="modal-title font-weight-bold">{platformToEdit ? 'Editar Plataforma' : 'Nueva Plataforma'}</h5>
                        <button type="button" className="close text-white" onClick={onClose}>&times;</button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body p-4">
                            <div className="form-group mb-3">
                                <label className="small font-weight-bold">Nombre (Ej: RAPPI)</label>
                                <input type="text" name="nombre_plataforma" value={platform.nombre_plataforma} onChange={(e) => setPlatform({...platform, nombre_plataforma: e.target.value})} className="form-control rounded-lg" required />
                            </div>
                            <div className="form-group mb-3">
                                <label className="small font-weight-bold">Comisión %</label>
                                <input type="number" step="0.01" name="porcentaje_comision" value={platform.porcentaje_comision} onChange={(e) => setPlatform({...platform, porcentaje_comision: e.target.value})} className="form-control rounded-lg" min="0" />
                            </div>
                            <div className="form-group mb-4">
                                <label className="small font-weight-bold">Recargo Fijo (%)</label>
                                <input type="number" name="recargo_cliente" value={platform.recargo_cliente} onChange={(e) => setPlatform({...platform, recargo_cliente: e.target.value})} className="form-control rounded-lg" min="0" />
                            </div>
                            <div className="custom-control custom-switch">
                                <input type="checkbox" className="custom-control-input" id="platformActive" name="activo" checked={platform.activo} onChange={(e) => setPlatform({...platform, activo: e.target.checked ? 1 : 0})} />
                                <label className="custom-control-label font-weight-bold" htmlFor="platformActive">Activa</label>
                            </div>
                        </div>
                        <div className="modal-footer border-0 bg-light">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                            <button type="submit" className="btn btn-primary font-weight-bold" disabled={isLoading}>Guardar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

// --- COMPONENTE PRINCIPAL ---
const AdministradorPlataformas = () => {
    const [plataformas, setPlataformas] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [platformToEdit, setPlatformToEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => { cargarPlataformas(); }, []);

    const cargarPlataformas = async () => {
        setLoading(true);
        try {
            const data = await obtenerPlataformasExternas(); // Usa el nuevo servicio GET
            setPlataformas(data || []);
        } catch (err) { toast.error("Error al cargar plataformas"); }
        finally { setLoading(false); }
    };

    // 🚩 CORRECCIÓN 2: HandleSave usa handleSave y llama a cargarPlataformas
    const handleSave = () => {
        toast.success("Configuración de plataforma guardada.");
        cargarPlataformas();
        setIsModalOpen(false);
        setPlatformToEdit(null);
    };

    const handleDelete = async (id, nombre) => {
        if (!window.confirm(`¿Seguro que desea eliminar la plataforma '${nombre}'?`)) return;
        try {
            await eliminarPlataforma(id); // 🚩 LLAMA AL NUEVO SERVICIO DE ELIMINACIÓN
            toast.success("Plataforma eliminada.");
            cargarPlataformas();
        } catch (err) { toast.error("Error al eliminar."); }
    };

    const filtered = plataformas.filter(p => p.nombre_plataforma.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <div className="container pt-5 mt-3 pb-5">
            <ToastContainer position="top-right" autoClose={3000} />
            
            {/* TÍTULO Y BOTÓN */}
            <div className="card border-0 shadow-sm rounded-xl p-4 mb-4">
                <div className="d-flex justify-content-between align-items-center">
                    <h1 className="h3 font-weight-bold text-dark mb-0">Configuración de Apps (Rappi/Uber)</h1>
                    <button onClick={() => { setPlatformToEdit(null); setIsModalOpen(true); }} className="btn btn-primary rounded-pill px-4 shadow-sm font-weight-bold">
                        <i className="fas fa-plus mr-2"></i> Nueva Plataforma
                    </button>
                </div>
            </div>

            {/* TABLA */}
            <div className="card shadow-lg p-0 rounded-xl">
                <div className="p-4 border-bottom">
                    <input type="text" className="form-control rounded-pill bg-light" placeholder="Buscar plataforma..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>

                <div className="table-responsive">
                    <table className="table table-hover mb-0">
                        <thead className="thead-light">
                            <tr>
                                <th className="py-3">Nombre</th>
                                <th className="py-3 text-center">Comisión (%)</th>
                                <th className="py-3 text-center">Recargo (%)</th>
                                <th className="py-3">Estado</th>
                                <th className="py-3 text-right">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="5" className="text-center py-4">Cargando...</td></tr>
                            ) : filtered.map((p) => (
                                <tr key={p.id}>
                                    <td className="font-weight-medium">{p.nombre_plataforma}</td>
                                    <td className="text-center">{p.porcentaje_comision}%</td>
                                    <td className="text-center">${Number(p.recargo_cliente).toLocaleString('es-CL')}</td>
                                    <td>
                                        <span className={`badge badge-pill ${p.activo ? 'badge-success' : 'badge-secondary'}`}>
                                            {p.activo ? 'Activa' : 'Inactiva'}
                                        </span>
                                    </td>
                                    <td className="text-right">
                                        <button onClick={() => { setPlatformToEdit(p); setIsModalOpen(true); }} className="btn btn-sm btn-light border-0 rounded-circle mr-2"><i className="fas fa-pen text-info"></i></button>
                                        <button onClick={() => handleDelete(p.id, p.nombre_plataforma)} className="btn btn-sm btn-light border-0 rounded-circle"><i className="fas fa-trash text-danger"></i></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {filtered.length === 0 && !loading && <div className="text-center py-5 text-muted">No hay plataformas configuradas.</div>}
            </div>

            {/* 🚩 MODAL DEFINIDO AQUÍ */}
            <PlatformFormModal
                isVisible={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSave={handleSave}
                platformToEdit={platformToEdit}
            />
        </div>
    );
};

export default AdministradorPlataformas;